import React, { useContext, useEffect, useState } from 'react';
import { MerchandiseWidget } from '@components/misc/MerchandiseWidget';
import { MerchandisingContent } from '@apis/models/zesty.api.model';
import ZestyApi from '@apis/zesty.apis';
import { GAEventArgsMaster } from '@app/models/gaevents.model';
import { getBrand } from '@helpers/brand.utils';
import ProfileContext from '@context/ProfileContext';

interface MerchandiseWidgetLoaderProps {
  page: string,
  gaClickEventArgs: GAEventArgsMaster;
}

export const DynamicMerchandiseWidget: React.FC<MerchandiseWidgetLoaderProps> = (
  props: React.PropsWithChildren<MerchandiseWidgetLoaderProps>) => {
  
  const [isLoading, setIsLoading] = useState(true);
  const [merchandisingContent, setMerchandisingContent] = useState<MerchandisingContent>({
    isActive: false,
    copyText: '',
    merchandisingUrl: '',
    imageIconUrl: '',
    navIconUrl: '',
    ctaText: undefined,
    brand: '',
    portalPage: '',
    states: [],
  })
  const { profile } = useContext(ProfileContext);
  const [showBanner, setShowBanner] = useState(false);

  const findContentForCustomer = (zestyContent: MerchandisingContent[]): MerchandisingContent => {
    const customerBrand = getBrand()
    const profileOffices = [...profile.offices, ...profile.workedWithOffices]
    return zestyContent.find((data) => {
      const isActive = data.isActive
      const showForBrand = customerBrand === data.brand
      const showForPage = data.portalPage === props.page
      const hasStateTargeting = data.states.length > 0

      if (isActive && showForBrand && showForPage) {
        return !hasStateTargeting || profileOffices?.some((office) => {
          return data.states.includes(office?.address?.state);
        });
      }
      return false;
    })
    
  };
  
  const updateMerchandisingBanner = (zestyContent: MerchandisingContent[]) => {
    const content = findContentForCustomer(zestyContent)
    if (content !== undefined) {
      setMerchandisingContent(content)
    }
    setShowBanner(content !== undefined)
  }

  useEffect(() => {
    ZestyApi.GetMerchandiseData()
      .then((zestyContent) => {
        if (zestyContent.length === 0) {
          console.warn('no merchandising information returned.');
          return;
        }
        updateMerchandisingBanner(zestyContent)
        setIsLoading(false)
      })
      .catch(() => {
        console.warn('getting merchandising information failed.');
        setIsLoading(false)
        })
  }, []);
  
  return (
    showBanner && <MerchandiseWidget
      loading={isLoading}
      htmlText={merchandisingContent.copyText}
      navigationUrl={merchandisingContent.merchandisingUrl}
      imageIconUrl={merchandisingContent.imageIconUrl}
      navIconUrl={merchandisingContent.navIconUrl}
      ctaText={merchandisingContent.ctaText}
      gaClickEventArgs={props.gaClickEventArgs}
    />
  )
  
}